import React, { useCallback, useMemo, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import HeroPitchCard from './hero/HeroPitchCard';
import HeroPortrait from './hero/HeroPortrait';
import useReducedMotion from '../hooks/useReducedMotion';
import useHeroScrollEffects from '../hooks/useHeroScrollEffects';
import useHeroPanelIntro from '../hooks/useHeroPanelIntro';
import useHeroCardParallax from '../hooks/useHeroCardParallax';
import SectionWave from './SectionWave';
import heroFond from '../assets/espaces-culturel/fond.jpg';

const RihenHero = ({ withWave = false }) => {
  const heroRef = useRef(null);
  const pitchRef = useRef(null);
  const portraitRef = useRef(null);
  const reducedMotion = useReducedMotion();
  const [introReady, setIntroReady] = useState(false);
  const handleIntroReady = useCallback((ready) => {
    setIntroReady(ready);
  }, []);

  const panelIntroConfig = useMemo(
    () => [
      { ref: pitchRef, introDelay: 8, initZ: 1.85 },
      { ref: portraitRef, introDelay: 22, initZ: 1.7 },
    ],
    [],
  );

  useHeroPanelIntro(heroRef, panelIntroConfig, reducedMotion, handleIntroReady);
  useHeroScrollEffects(heroRef, reducedMotion, introReady);
  useHeroCardParallax(heroRef, reducedMotion);

  return (
    <section
      className={`rihen-hero${withWave ? ' rihen-hero--with-wave' : ''}`}
      id="hero"
      ref={heroRef}
    >
      <div
        className="rihen-hero-bg"
        style={{
          backgroundImage: `url('${heroFond}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        aria-hidden="true"
      />

      <div className="rihen-hero-scrim" aria-hidden="true" />

      <div className="rihen-hero-grid hero-stage">
        <div className="hero-stage__spine" aria-hidden="true" />
        <HeroPitchCard ref={pitchRef} />
        <HeroPortrait ref={portraitRef} />
      </div>

      <div className="rihen-scroll-cue" aria-hidden="true">
        <div className="rihen-scroll-cue__track">
          <span className="line" />
          <ChevronDown size={18} className="rihen-scroll-cue__arrow" strokeWidth={1.5} />
        </div>
      </div>

      {withWave ? <SectionWave flip priority className="section-wave--hero-end" /> : null}
    </section>
  );
};

export default RihenHero;
